import api from './api'
import { User } from '@/store/authStore'

interface AuthResponse {
  access_token: string
  refresh_token: string
  token_type: string
  user: User
}

// Авторизация через Telegram Mini App
export async function loginWithTelegram(initData: string): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>('/auth/telegram', {
    init_data: initData,
  })
  return response.data
}

// Обновление токена
export async function refreshToken(refreshToken: string): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>('/auth/refresh', {
    refresh_token: refreshToken,
  })
  return response.data
}

// Получить текущего пользователя
export async function getCurrentUser(): Promise<User> {
  const response = await api.get<User>('/auth/me')
  return response.data
}

// Выход
export async function logout(): Promise<void> {
  await api.post('/auth/logout')
}
